module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"CreateSuccess":"Le groupe a bien été créé"}}')
  delete Component.options._Ctor
}
